import { ReactChild, ReactElement, ReactFragment, ReactPortal } from 'react';
import Modal from '@components/Modal';

type UpsellDetailModalProps = {
    close: () => void;
    UpsellDetails: any;
}

const UpsellDetailsModal = (props : UpsellDetailModalProps) : ReactElement => {

    const {
        close,
        UpsellDetails
    } = props;

    return(
        <div className="upsell-modal">
            <Modal close={close}>
                <div className="upsell-modal-content">
                    <h2 className="upsell-modal-title">{UpsellDetails.title}</h2>
                    <img className="upsell-modal-img" src={UpsellDetails.icon} alt="Lens image"/>
                    <p className='upsell-modal-long-description'>{UpsellDetails.long_description}</p>
                </div>
            </Modal>
        </div>
    )
}
  
export default UpsellDetailsModal;